// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__2jhAF","footer":"Card_footer__3xx2z","btns":"Card_btns__3O4y3","video":"Card_video__2JXlR","icon":"Card_icon__115cN"};